var exports = {
  "iE": "xaee3c4fa--8c2f56--wrapper",
  "Qq": "xaee3c4fa--8c2f56--text",
};

module.exports = exports;
